@if (isVisible | async) {
<a (click)="increaseSize()">Show more</a>
}
